import React, { useEffect, useRef, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { FaEdit, FaTrashAlt, FaEye } from "react-icons/fa";
import BSPagination from "../../Components/pagination";
import { useNavigate } from "react-router-dom";
import {
  deleteCategoryById,
  getPaginatedGCList,
  searchCategories,
  toggleCategoryStatus,
} from "../../services/axios/apiManager";
import { handleErrors } from "../../services/dataManager";
import AddEditCatModal from "./addEditGameCatModal";
import CategoryDetails from "./CategoryDetails";
import { toast } from "sonner";
import $ from "jquery";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";

const GameCategoryList = ({
  gameCategories,
  setGameCategories,
  pagination,
  setPagination,
  granted,
}) => {
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [modalOptions, setModalOptions] = useState({});
  const [showOptionsModal, setShowOptionsModal] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [openDetailsModal, setOpenDetailsModal] = useState(false);
  const tableRef = useRef(null);

  const fetchCategories = async (pgntn, filter = "") => {
    const res = await getPaginatedGCList(
      pgntn.currentPage,
      pgntn.pageSize,
      filter
    );
    if (res?.data?.success) {
      setGameCategories(res.data.data);
      res.data.pagination && setPagination(res.data.pagination);
    } else {
      handleErrors(res, navigate, "Categories list:");
    }
  };

  useEffect(() => {
    fetchCategories(pagination, query);
  }, [pagination.currentPage, pagination.pageSize]);

  const handleSearch = (e) => {
    const str = e.target.value;
    setQuery(str);
    setPagination((p) => ({ ...p, currentPage: 1 }));
    if (str) {
      searchCategories(str).then((res) => {
        if (res?.data?.success) {
          setGameCategories(res.data.data);
          res.data.pagination && setPagination(res.data.pagination);
        } else {
          handleErrors(res, navigate, "Search Categories:");
        }
      });
    } else {
      fetchCategories(pagination);
    }
  };

  const handlePageChange = (page) => {
    setPagination((p) => ({ ...p, currentPage: page }));
  };

  const handleStatusChange = (cat) => {
    if (!granted.some((perm) => perm.type === "toggle-status")) {
      return toast.error("You don't have neccessary permissions to do this operation..");
    }
    setModalOptions({
      header: "Change Status",
      body: `Change status of \"${cat.name}\"?`,
      okay: "Change",
      method: changeStatus,
      data: { id: cat.id, status: cat.status === 1 ? 0 : 1 },
    });
    setShowOptionsModal(true);
  };

  const changeStatus = async (data) => {
    const res = await toggleCategoryStatus(data);
    if (res?.data?.success) fetchCategories(pagination, query);
    setShowOptionsModal(false);
  };

  const handleDelete = (cat) => {
    if (!granted.some((perm) => perm.type === "delete")) return;
    setModalOptions({
      header: "Delete Category",
      body: `Delete \"${cat.name}\"?`,
      okay: "Delete",
      method: deleteCategory,
      data: { id: cat.id },
    });
    setShowOptionsModal(true);
  };

  const deleteCategory = async (data) => {
    const res = await deleteCategoryById(data.id);
    if (res?.data?.success) fetchCategories(pagination, query);
    setShowOptionsModal(false);
  };

  const handleOpenAddEditModal = (cat) => {
    setSelectedCategory(cat);
    setShowModal(true);
  };

  const handleOpenDetails = (cat) => {
    setSelectedCategory(cat);
    setOpenDetailsModal(true);
  };

  useEffect(() => {
    const rows = gameCategories.map((cat) => [
      cat.id,
      cat.name,
      `<button class=\"btn btn-sm status-btn ${
        cat.status === 1 ? "text-success" : "text-danger"
      }\" data-id=\"${cat.id}\" title="change status">${cat.status === 1 ? "Active" : "Inactive"}</button>`,
      `<button class=\"btn btn-sm btn-outline-success view-btn me-1\" data-id=\"${cat.id}\" title="view details"><i class=\"fas fa-eye\"></i></button>` +
        (granted.some((p) => p.type === "update")
          ? `<button class=\"btn btn-sm btn-outline-primary edit-btn me-1\" data-id=\"${cat.id}\" title="edit"><i class=\"fas fa-edit\"></i></button>`
          : "") +
        (granted.some((p) => p.type === "delete") &&
        !cat.is_associated &&
        cat?.status === 0
          ? `<button class=\"btn btn-sm btn-outline-danger delete-btn\" data-id=\"${cat.id}\" title="delete"><i class=\"fas fa-trash-alt\"></i></button>`
          : ""),
    ]);

    const cfg = {
      data: rows,
      columns: [
        { title: "ID", className: "text-start" },
        { title: "Category Name" },
        { title: "Status", className: "text-end", orderable: false },
        { title: "Action", className: "text-end", orderable: false },
      ],
      destroy: true,
      responsive: true,
      paging: false,
      searching: false,
      pageLength: pagination.pageSize || 10,
    };

    const tbl = $(tableRef.current);
    if ($.fn.dataTable.isDataTable(tableRef.current)) {
      tbl.DataTable().clear().rows.add(rows).draw();
    } else {
      tbl.DataTable(cfg);
    }

    tbl.off("click", ".view-btn").on("click", ".view-btn", (e) => {
      const id = +$(e.currentTarget).data("id");
      handleOpenDetails(gameCategories.find((c) => c.id === id));
    });
    tbl.off("click", ".edit-btn").on("click", ".edit-btn", (e) => {
      const id = +$(e.currentTarget).data("id");
      handleOpenAddEditModal(gameCategories.find((c) => c.id === id));
    });
    tbl.off("click", ".delete-btn").on("click", ".delete-btn", (e) => {
      const id = +$(e.currentTarget).data("id");
      handleDelete(gameCategories.find((c) => c.id === id));
    });
    tbl.off("click", ".status-btn").on("click", ".status-btn", (e) => {
      const id = +$(e.currentTarget).data("id");
      handleStatusChange(gameCategories.find((c) => c.id === id));
    });

    return () => tbl.DataTable().destroy();
  }, [gameCategories, pagination.pageSize, pagination.currentPage, granted]);

  return (
    <div className="container py-4 text-light bg-dark p-3 rounded mb-4">
      <div className="row align-items-center mb-4">
        <div className="col-md-4">
          <Form.Control
            placeholder="Search Categories..."
            value={query}
            onChange={handleSearch}
            className="bg-dark text-light border-light"
            style={{ width: "45%" }}
          />
        </div>
        <div className="col-md-8 text-end">
          {granted?.some((perm) => perm?.type === "create") && (
            <Button
              title="Add New Category"
              className="btn btn-success"
              onClick={() => {
                handleOpenAddEditModal({});
              }}
            >
              <i className="bi bi-plus-circle"></i> Add Game Category
            </Button>
          )}
        </div>
      </div>

      <div className="table-responsive">
        <table
          ref={tableRef}
          className="table table-striped table-dark w-100"
        />
      </div>

      <div className="d-flex justify-content-end mt-2">
        <div className="mx-4 py-2">
            <span className="text-light">{`Rows/Page ${pagination.pageSize || 0}, Total records ${pagination?.totalRecords || 0}`}</span>
          </div>
        <BSPagination
          currentPage={pagination.currentPage}
          totalPages={pagination.totalPages}
          onPageChange={handlePageChange}
          siblingCount={2}
          showFirstLast
        />
      </div>

      <AddEditCatModal
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        showModal={showModal}
        setShowModal={setShowModal}
        fetchCategories={fetchCategories}
        pagination={pagination}
      />

      <CategoryDetails
        selectedCategory={selectedCategory}
        setSelectedCategory={setSelectedCategory}
        openDetailsModal={openDetailsModal}
        setOpenDetailsModal={setOpenDetailsModal}
      />

      <Modal
        show={showOptionsModal}
        onHide={() => setShowOptionsModal(false)}
        centered
        className="text-light"
      >
        <Modal.Header closeButton className="bg-dark border-0">
          <Modal.Title>{modalOptions.header}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-dark">{modalOptions.body}</Modal.Body>
        <Modal.Footer className="bg-dark border-0">
          <Button
            variant="secondary"
            onClick={() => setShowOptionsModal(false)}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={() => modalOptions.method(modalOptions.data)}
          >
            {modalOptions.okay}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default GameCategoryList;
